module.exports = __webpack_public_path__ + "static/media/logo.7b73f013.svg";